  $(document).ready(function() {
    $('#create_customer').on('click',
                 '[type="submit"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("Debe aceptar los términos y condiciones para registrarte.");
        return false;
      }
      if ($('#ap_agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("Debe aceptar el aviso de privacidad para registrarte.");
        return false;
      }
    });
  });

// Terms & Conditions checkbox at the cart
 
$(document).ready(function () {
    $("body").on(
        "click",
        '[name="checkout"], [name="goto_pp"], [name="goto_gc"]',
        function () {
            if ($("#agree").is(":checked")) {
                $(this).submit();
            } else {
                alert(
                    "Debe aceptar los términos y condiciones de venta para pagar."
                );
                return false;
            }
        }
    );
});

